import { styled } from "styled-components";

export const SliderContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 48px;
  width: 100%;
  position: relative;

  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start; /* Optional: center align everything */
  gap: 8px; /* Spacing between text and toggle */

  ${({ theme }) => theme.breakpoints.md.query} {
    align-items: center;
  }
`;

export const LabelText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #878787;
`;
